import { createStore } from './Store';
import { QuestionnaireStoreApi } from './QuestionnaireStore';

export interface QuestionnaireStateStore {
  isFormDataModified: () => boolean;
}

export const [
  useQuestionnaireStateStore,
  QuestionnaireStateStoreApi
] = createStore<QuestionnaireStateStore>('QuestionnaireStateStore', () => ({
  isFormDataModified: () => QuestionnaireStoreApi.getState().isFormDataModified
}));
